import { API, Auth } from "src/domains/shared/utils/amplifyCompat";
import { DRONESQUARE_API_GATEWAY } from "src/domains/shared/constants/constants";
import { ParsedUser, User, UserWithProjects } from "./user.model";
import { toAccountDeletionError } from "./accountDeletion";

class UserRepository {
  async getUser(): Promise<User> {
    const user = await Auth.currentAuthenticatedUser();

    return user.attributes as unknown as User;
  }

  /**
   * 회원 탈퇴 — 게이트웨이 `DronesquareApi-V1` 의 endpoint 는 main-api 라 `DELETE /v1/users/me` 를 때린다.
   * 실패는 `AccountDeletionError`(status + wire message)로 정규화해 던진다 — 호출측이 409/400 을 가른다.
   */
  async deleteUser(): Promise<void> {
    try {
      await API.del(DRONESQUARE_API_GATEWAY, "users/me", {});
    } catch (error) {
      throw toAccountDeletionError(error);
    }
  }

  async getUserWithProjects(): Promise<UserWithProjects> {
    return API.get(DRONESQUARE_API_GATEWAY, "users/userinfo", {});
  }

  async patchUser(data: ParsedUser) {
    return API.patch(DRONESQUARE_API_GATEWAY, "users/me", {
      body: {
        ...data,
        phone_number_verified: "true",
        email_verified: "true",
      },
    });
  }
}

export default new UserRepository();
